var api = require("!../../../../../../node_modules/.pnpm/style-loader@1.3.0_webpack@5.76.0/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../../../node_modules/.pnpm/mini-css-extract-plugin@1.6.0_webpack@5.76.0/node_modules/mini-css-extract-plugin/dist/loader.js??ruleSet[1].rules[3].use[2]!../../../../../../node_modules/.pnpm/css-loader@4.3.0_webpack@5.76.0/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[3]!../../../../../../node_modules/.pnpm/postcss-loader@5.3.0_postcss@7.0.39_webpack@5.76.0/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[3].use[4]!../../../../../../node_modules/.pnpm/sass-loader@10.2.0_sass@1.66.1_webpack@5.76.0/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[3].use[5]!./anglrC-alert.scss");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};